/**
 * MATAFOME — API DE CONTROLE DE CAIXA E FLUXO FINANCEIRO
 */

import { safeApiFetch, getAuthHeaders, getApiBase, currentToken } from './core.api';

export async function fetchCurrentCashier() {
    const res = await safeApiFetch('/api/cashier/current', {
        headers: getAuthHeaders()
    });
    if (!res.ok) throw new Error('Falha ao carregar status atual do caixa.');
    return res.json();
}

export async function openCashier(operatorName, initialCash = 0, notes = '') {
    const res = await safeApiFetch('/api/cashier/open', {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ operatorName, initialCash, notes })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao abrir turno de caixa.');
    return data;
}

export async function addCashierMovement(type, amount, reason) {
    const res = await safeApiFetch('/api/cashier/movement', {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ type, amount, reason })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao registrar movimentação no caixa.');
    return data;
}

export async function closeCashier(finalCashCounted, notes = '') {
    const res = await safeApiFetch('/api/cashier/close', {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ finalCashCounted, notes })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Falha ao fechar turno de caixa.');
    return data;
}

// ----------------------------------------------------
export function getCashierReceiptUrl(shiftId, { width = 80, auto = true } = {}) {
    const token = currentToken || (typeof localStorage !== 'undefined' ? localStorage.getItem('matafome_token') : '') || '';
    return `${getApiBase()}/api/cashier/${shiftId}/receipt?width=${width}&auto=${auto ? 'true' : 'false'}&token=${encodeURIComponent(token)}`;
}

// MESAS DO SALÃO & COMANDAS (DINE-IN)
// ----------------------------------------------------
